<template>
  <feed></feed>
</template>

<script>
import Feed from "@/components/Feed";

export default {
  name: "CreateFeed",
  components: { Feed }
}
</script>

<style scoped>

</style>
